import { render, staticRenderFns } from "./AdminMember.vue?vue&type=template&id=ddf839b6&scoped=true"
import script from "./AdminMember.vue?vue&type=script&lang=js"
export * from "./AdminMember.vue?vue&type=script&lang=js"
import style0 from "./AdminMember.vue?vue&type=style&index=0&id=ddf839b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf839b6",
  null
  
)

export default component.exports